export default __webpack_public_path__ + "static/media/O-050.572fa315.png";